/* eslint-disable react/jsx-wrap-multilines */
import React, {useEffect, useRef, useState} from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import {
    Button,
    TextField,
    CircularProgress, DialogTitle, DialogActions, Dialog, DialogContent, Autocomplete, Stack
} from '@mui/material';
import {Box,  Typography} from "@mui/material";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {DatiProg, FlgDMSList, CompProgList, TipoInstList, TipoMigList, TipoProgList} from "./types";
import {useCreateDatiProg  } from "./Services";
import {useGetDipendenti, useGetProgetti,useGetProgettiNotDatiProg} from "../gestversore/Services";
import {valutaValidator} from "../../components/YupValidators";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "../gestversore/VersOreNoteAssist";



interface AddDatiProgProps {
  onClose: () => void;
}

// const AddDatiProg  = ()  => {
const AddDatiProg: React.FC<AddDatiProgProps> = ({ onClose }) => {

  const validationSchema = Yup.object().shape({
  id: Yup.string().required("Progetto è obbligatorio"),
  ref: Yup.string().required("Ref è obbligatorio"),
  refcli: Yup.string(),
  tipoprog: Yup.string(),
  compprog: Yup.string(),
  datakickoffpian: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data kickoff pianificata deve essere una data valida"),
  datakickoffeff: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data kickoff effettiva deve essere una data valida"),
  datagantt: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data Gantt deve essere una data valida"),
  datagolivepian: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data go live pianificata deve essere una data valida").required("DataGoLivePian è obbligatorio"),
  datagoliveeff: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data go live effettiva deve essere una data valida"),
  data1sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 1 deve essere una data valida"),
  data2sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 2 deve essere una data valida"),
  data3sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 3 deve essere una data valida"),
  data4sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 4 deve essere una data valida"),
  data5sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 5 deve essere una data valida"),
  percomp: Yup.number().required().typeError("Percentuale completamento deve essere un numero"),
  tipoinst: Yup.string(),
  flgdms: Yup.string(),
  codprogdms: Yup.string(),
  datafirmakickoff: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data firma kickoff deve essere una data valida"),
  datacoll: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data colloquio deve essere una data valida"),
  note: Yup.string(),
  ditta: Yup.number().typeError("Ditta deve essere un numero"),
  tipomig: Yup.string(),
  datapercomp: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data per completamento deve essere una data valida").required("DataPercComp è obbligatorio"),
  dataagg: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data aggiornamento deve essere una data valida").required("DataAgg è obbligatorio"),
  // ricavi: valutaValidator,

});

   const [id, setId] = useState('');
   const [ditta, setDitta] = useState(2);
   const [ref, setRef] = useState('');
   const [tipoprog, setTipoProg] = useState('');
   const [tipomig, setTipoMig] = useState('');
   const [tipoinst, setTipoInst] = useState('');
   const [compprog, setCompProg] = useState('');
   const [flgdms, setFlgDms] = useState('');





  const { mutateAsync: createDatiProg, isPending: isCreatingDatiProg } = useCreateDatiProg();

  // solo progetti BS
  const {  data: ProgettiApiResponse } = useGetProgettiNotDatiProg(2);

  const {  data: DipendentiApiResponse } = useGetDipendenti(2,'');

  const { setValue, register,control, handleSubmit, formState: { errors },reset,watch} = useForm({ resolver: yupResolver(validationSchema)});

  const clickedButtonRef = useRef<string | null>(null);


   const role = localStorage.getItem('keyrole') || '';

   let isdatiprogettoadmin = false;

   if (role.includes('TimeReportAdmin') || role.includes('TimeReportDatiProgetto') ) {
       isdatiprogettoadmin = true;
   };




const handleSelection = (setter: (value: any) => void, fieldName: any, value: any) => {
    // console.log('handleSelection called with:', value);
    if (value) {
          // console.log('Setting field:', fieldName, 'with value:', value);
        setValue(fieldName, value);
        setter(value);
    }
    // console.log('values of form ', watch());
};



  const handleButtonClick = (buttonId: string) => {
        clickedButtonRef.current = buttonId;
      };


 const onSubmit: SubmitHandler<DatiProg> = async (data) => {
           const copilotConfig = await loadVersOreCopilotConfig();

           await createDatiProg({
               ...data,
               ditta: 2,
               // note: clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value,
           });
           onClose();

   };

 const handleClose = () => {
            onClose();
          };

  return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
    <Dialog onClose={onClose} open fullWidth maxWidth="lg">
    <DialogTitle>
        {/*<Typography variant="h2">Nuovo</Typography>*/}
    </DialogTitle>
        <DialogContent>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={2} direction="column" alignItems="flex-start">
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '25%'}}>
                            <TextField
                                id="dataagg"
                                type="date"
                                label="Data Agg.Prog."
                                fullWidth margin="dense"
                                {...register('dataagg')}
                                error={!!errors.dataagg}
                            />
                            <Typography variant="caption" color="error">{errors.datakickoffpian?.message}</Typography>
                        </Box>
                       <Box sx={{ width: '100%' }}>
                            <Autocomplete
                                disablePortal
                                id="id"
                                getOptionLabel={(option) => `(${option.codprog?.trim()}) ${option.desprog}`}
                               // value={ProgettiApiResponse?.results.find((item) => item.idprog === idprog) || null}
                                options={ProgettiApiResponse?.results ?? []}
                                onChange={(event, value) => {handleSelection(setId, 'id', value?.codprog);handleSelection(setDitta, 'ditta', value?.ditta);}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Progetto" fullWidth />}
                            />
                                <Typography variant="caption" color="error">{errors.id?.message}</Typography>
                        </Box>
                        <Box sx={{width: '25%'}}>
                            <TextField
                                id="percomp"
                                label="Perc.Comp"
                                fullWidth margin="dense"
                                {...register('percomp')}
                                error={!!errors.percomp}
                            />
                            <Typography variant="caption" color="error">{errors.percomp?.message}</Typography>
                        </Box>
                         <Box sx={{width: '40%'}}>
                            <TextField
                                id="datapercomp"
                                type="date"
                                label="Data Perc.Comp."
                                fullWidth margin="dense"
                                {...register('datapercomp')}
                                error={!!errors.datapercomp}
                            />
                            <Typography variant="caption" color="error">{errors.datapercomp?.message}</Typography>
                        </Box>
                       </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{ width: '40%' }}>
                            <Autocomplete
                                disablePortal
                                id="ref"
                                options={DipendentiApiResponse?.results ?? []}
                                onChange={(event, value) => {handleSelection(setRef, 'ref', value?.coddip);handleSelection(setDitta, 'ditta', value?.codditta);}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Ref.Interno" fullWidth />}

                            />
                                <Typography variant="caption" color="error">{errors.ref?.message}</Typography>
                        </Box>

                        <Box sx={{width: '40%'}}>
                            <TextField
                                id="refcli"
                                label="Ref.Cliente"
                                fullWidth margin="dense"
                                {...register('refcli')}
                                error={!!errors.refcli}
                            />
                            <Typography variant="caption" color="error">{errors.refcli?.message}</Typography>
                        </Box>
                        {/*{isdatiprogettoadmin && (*/}
                        {/* <Box sx={{width: '20%'}}>*/}
                        {/*    <TextField*/}
                        {/*        id="ricavi"*/}
                        {/*        label="Ricavi"*/}
                        {/*        fullWidth margin="dense"*/}
                        {/*        {...register('ricavi')}*/}
                        {/*        error={!!errors.ricavi}*/}

                        {/*    />*/}
                        {/*    <Typography variant="caption" color="error">{errors.ricavi?.message}</Typography>*/}
                        {/*</Box> )}*/}
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '33%'}}>
                            <Autocomplete
                                disablePortal
                                id="tipoprog"
                                // value={opzione}
                                options={TipoProgList}
                                onChange={(event, value) => {handleSelection(setTipoProg, 'tipoprog', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Tipo Prog" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.tipoprog?.message}</Typography>
                        </Box>
                          <Box sx={{width: '33%'}}>
                           <Autocomplete
                                disablePortal
                                id="tipomig"
                                // value={opzione}
                                options={TipoMigList}
                                onChange={(event, value) => {handleSelection(setTipoMig, 'tipomig', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Tipo Mig" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.tipomig?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <Autocomplete
                                disablePortal
                                id="tipoinst"
                                // value={opzione}
                                options={TipoInstList}
                                onChange={(event, value) => {handleSelection(setTipoProg, 'tipoinst', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Tipo Inst" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.tipoinst?.message}</Typography>
                        </Box>
                     </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '33%'}}>
                           <Autocomplete
                                disablePortal
                                id="compprog"
                                // value={opzione}
                                options={CompProgList}
                                onChange={(event, value) => {handleSelection(setTipoProg, 'compprog', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Comp. Prog." fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.compprog?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                           <Autocomplete
                                disablePortal
                                id="flgdms"
                                // value={opzione}
                                options={FlgDMSList}
                                onChange={(event, value) => {handleSelection(setTipoProg, 'flgdms', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Flg DMS" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.flgdms?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="codprogdms"
                                label="Cod Progetto DMS"
                                fullWidth margin="dense"
                                {...register('codprogdms')}
                                error={!!errors.codprogdms}
                            />
                            <Typography variant="caption" color="error">{errors.codprogdms?.message}</Typography>
                        </Box>
                     </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                      <Box sx={{width: '33%'}}>
                            <TextField
                                id="datafirmakickoff"
                                type="date"
                                label="Data Kickoff Firma"
                                fullWidth margin="dense"
                                {...register('datafirmakickoff')}
                                error={!!errors.datafirmakickoff}
                            />
                            <Typography variant="caption" color="error">{errors.datafirmakickoff?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datakickoffpian"
                                type="date"
                                label="Data Kickoff Pian."
                                fullWidth margin="dense"
                                {...register('datakickoffpian')}
                                error={!!errors.datakickoffpian}
                            />
                            <Typography variant="caption" color="error">{errors.datakickoffpian?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datakickoffeff"
                                type="date"
                                label="Data Kickoff Eff."
                                fullWidth margin="dense"
                                {...register('datakickoffeff')}
                                error={!!errors.datakickoffeff}
                            />
                            <Typography variant="caption" color="error">{errors.datakickoffeff?.message}</Typography>
                        </Box>
                        </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datagantt"
                                type="date"
                                label="Data Gantt"
                                fullWidth margin="dense"
                                {...register('datagantt')}
                                error={!!errors.datagantt}
                            />
                            <Typography variant="caption" color="error">{errors.datagantt?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datagolivepian"
                                type="date"
                                label="Data GoLive Pian."
                                fullWidth margin="dense"
                                {...register('datagolivepian')}
                                error={!!errors.datagolivepian}
                            />
                            <Typography variant="caption" color="error">{errors.datagolivepian?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datagoliveeff"
                                type="date"
                                label="Data GoLive Eff."
                                fullWidth margin="dense"
                                {...register('datagoliveeff')}
                                error={!!errors.datagoliveeff}
                            />
                            <Typography variant="caption" color="error">{errors.datagoliveeff?.message}</Typography>
                        </Box>
                        </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data1sal"
                                type="date"
                                label="Data Sal 1"
                                fullWidth margin="dense"
                                {...register('data1sal')}
                                error={!!errors.data1sal}
                            />
                            <Typography variant="caption" color="error">{errors.data1sal?.message}</Typography>
                        </Box>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data2sal"
                                type="date"
                                label="Data Sal 2"
                                fullWidth margin="dense"
                                {...register('data2sal')}
                                error={!!errors.data2sal}
                            />
                            <Typography variant="caption" color="error">{errors.data2sal?.message}</Typography>
                        </Box>

                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data3sal"
                                type="date"
                                label="Data Sal 3"
                                fullWidth margin="dense"
                                {...register('data3sal')}
                                error={!!errors.data3sal}
                            />
                            <Typography variant="caption" color="error">{errors.data3sal?.message}</Typography>
                        </Box>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data4sal"
                                type="date"
                                label="Data Sal 4"
                                fullWidth margin="dense"
                                {...register('data4sal')}
                                error={!!errors.data4sal}
                            />
                            <Typography variant="caption" color="error">{errors.data4sal?.message}</Typography>
                        </Box>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data5sal"
                                type="date"
                                label="Data Sal 5"
                                fullWidth margin="dense"
                                {...register('data5sal')}
                                error={!!errors.data5sal}
                            />
                            <Typography variant="caption" color="error">{errors.data5sal?.message}</Typography>
                        </Box>
                         <Box sx={{width: '20%'}}>
                            <TextField
                                id="datacoll"
                                type="date"
                                label="Data Coll."
                                fullWidth margin="dense"
                                {...register('datacoll')}
                                error={!!errors.datacoll}
                            />
                            <Typography variant="caption" color="error">{errors.datacoll?.message}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                    <Box sx={{width: '100%'}}>
                        <Controller
                            name="note"
                            control={control}
                            render={({ field, fieldState }) => (
                                <VersOreNoteAssist
                                    textFieldId="dati-prog-add-note"
                                    value={String(field.value || '')}
                                    onChange={field.onChange}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    rows={3}
                                    maxLength={2000}
                                />
                            )}
                        />
                    </Box>
                    </Stack>

                    <Stack direction="row"  justifyContent="flex-end" spacing={1}  sx={{ marginTop: '15px', alignSelf: 'flex-end', width: '100%' }}>
                        <Button color="primary" type="reset" variant="outlined">CANCELLA</Button>
                        <Button variant="contained" onClick={onClose} color="error">CHIUDI</Button>
                        <Button
                            id="save"
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isCreatingDatiProg}
                            startIcon={isCreatingDatiProg ? <CircularProgress color="inherit" size={25}/> : null}
                            onClick={() => handleButtonClick('save')}>
                            SALVA
                        </Button>
                    </Stack>
                </Stack>
            </form>


        </DialogContent>
    </Dialog>

  );
};

export default AddDatiProg;
